import jobReducer from './jobReducer';

export default jobReducer;
